var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinManagerOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 46.5,
    rx: 6,
    ry: 1.5,
    fill: "#5E656E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7485 20.612C42.6936 9.27142 33.0561 0.277722 21.7392 1.63602C13.5536 2.61656 6.78854 9.23927 5.4936 17.5739C5.0698 20.3066 5.21107 22.9428 5.82322 25.3942C6.69436 28.8984 8.73486 31.9847 11.3326 34.4361L24.1171 46.5L36.6348 34.4602C39.9938 31.2292 42.3247 26.9212 42.6936 22.2194C42.7328 21.689 42.7563 21.1505 42.7485 20.604V20.612Z",
    fill: "#2559F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9993 29.7486C29.8333 29.7486 32.7486 25.8314 32.7486 20.9993C32.7486 16.1672 29.8333 12.25 23.9993 12.25C18.1653 12.25 15.25 16.1672 15.25 20.9993C15.25 25.8314 18.1653 29.7486 23.9993 29.7486Z",
    fill: "#FCC629"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 17.5625C23.375 18.4524 22.9617 19.2458 22.3165 19.7612C21.8146 19.5928 21.173 19.4375 20.5625 19.4375C19.952 19.4375 19.3104 19.5928 18.8085 19.7612C18.1633 19.2458 17.75 18.4524 17.75 17.5625C17.75 16.0092 19.0092 14.75 20.5625 14.75C22.1158 14.75 23.375 16.0092 23.375 17.5625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 17.5625C30.25 18.4524 29.8367 19.2458 29.1915 19.7612C28.6896 19.5928 28.048 19.4375 27.4375 19.4375C26.827 19.4375 26.1854 19.5928 25.6835 19.7612C25.0383 19.2458 24.625 18.4524 24.625 17.5625C24.625 16.0092 25.8842 14.75 27.4375 14.75C28.9908 14.75 30.25 16.0092 30.25 17.5625Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 19.125C21.9105 19.125 22.75 18.2855 22.75 17.25C22.75 16.2145 21.9105 15.375 20.875 15.375C19.8395 15.375 19 16.2145 19 17.25C19 18.2855 19.8395 19.125 20.875 19.125Z",
    fill: "#16191D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 19.125C28.1605 19.125 29 18.2855 29 17.25C29 16.2145 28.1605 15.375 27.125 15.375C26.0895 15.375 25.25 16.2145 25.25 17.25C25.25 18.2855 26.0895 19.125 27.125 19.125Z",
    fill: "#16191D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.625C18.375 26.625 18.375 21 18.375 21H29.625C29.625 21 29.625 26.625 24 26.625Z",
    fill: "#FF6168"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21.3125V21H29V21.3125C29 21.6577 28.7202 21.9375 28.375 21.9375H19.625C19.2798 21.9375 19 21.6577 19 21.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinManagerOn);
export default __webpack_public_path__ + "static/media/icon-pin-manager-on.7dd8cb36fa43ea7356a727b951e302ad.svg";
export { ForwardRef as ReactComponent };